import type { LocaleCopy } from '../types';
import { homeIt } from './home';
import { chromeIt } from './chrome';
import { aboutIt } from './about';
import { allergensIt } from './allergens';

export const it: LocaleCopy = {
  home: homeIt,
  chrome: chromeIt,
  about: aboutIt,
  allergens: allergensIt,
};
